import React from "react";
import { getLicenseStatusName } from "./HistoryLicenseModel";
import InformTable from "../Components/InformTable";
import { HistoryAction } from "../HistoryActionModel";
import { buildModifiedTableData, isDateProperty } from "../utils/historyActionHelpers";
import { formatDateIfValid } from "../utils/dateHelpers";

const formatLicenseValue = (property: string, value: any): string | null => {
    if (value === null || value === undefined) return null;
    if (property === "Status") return getLicenseStatusName(Number(value));
    if (isDateProperty(property)) return formatDateIfValid(value) ?? String(value);
    return String(value);
};

const LicenseTransaction: React.FC<{ action: HistoryAction }> = ({ action }) => {
    const general = [{ property: "Key", value: action.EntityName }];
    const { dataOld, dataNew } = buildModifiedTableData(
        action.Changes,
        formatLicenseValue,
        ["ModifyDate"]
    );

    return (
        <div className="inform_panel">
            <InformTable data={general} label="General" />
            {dataOld.length > 0 && <InformTable data={dataOld} label="Old Version" />}
            {dataNew.length > 0 && <InformTable data={dataNew} label="New Version" />}
        </div>
    );
};

export default LicenseTransaction;
